<section class="pv2-price-panel" [class.pv2-price-panel--page]="modoPagina">
  <header class="pv2-price-panel__header">
    <div>
      <h2>Tabelas preços</h2>
      <p>{{ tabelasConfiguradasLabel }}</p>
    </div>
    <div class="pv2-price-panel__actions">
      <button type="button" class="btn btn-success" (click)="novaTabela()" [disabled]="gerandoTabelaPadrao">
        <span class="fa fa-plus mr-1"></span>
        Nova tabela
      </button>
      <button type="button" class="btn btn-light" *ngIf="!modoPagina" (click)="closeRequested.emit()">
        <span class="fa fa-times mr-1"></span>
        Fechar
      </button>
    </div>
  </header>

  <div class="pv2-price-panel__body" *ngIf="!loading; else loadingTpl">
    <div class="pv2-price-list">
      <button type="button"
              class="pv2-price-list__item"
              *ngFor="let tabela of tabelas; let i = index"
              [class.is-active]="tabelaSelecionada?.id === tabela.id"
              (click)="selecioneTabela(tabela)">
        <span class="pv2-price-list__icon" [ngClass]="cardTone(i)">
          <span class="fa" [ngClass]="cardIcon(i)"></span>
        </span>
        <span class="pv2-price-list__text">
          <strong>{{ tabela.nome }}</strong>
          <span>Prioridade {{ tabela.prioridade || 0 }}</span>
        </span>
        <span class="pv2-price-status" [class.is-active]="tabela.ativo">{{ tabela.ativo ? 'Ativa' : 'Inativa' }}</span>
        <span class="pv2-price-status pv2-price-status--availability"
              [class.is-active]="tabelaDisponivelAgora(tabela)">
          {{ tabelaDisponivelAgora(tabela) ? 'Disponível' : 'Indisponível' }}
        </span>
      </button>
      <div class="pv2-price-empty pv2-price-empty--generating" *ngIf="!tabelas.length && gerandoTabelaPadrao">
        <span class="k-icon k-i-loading"></span>
        Gerando tabela preços padrão...
      </div>
    </div>

    <main class="pv2-price-editor" *ngIf="draft; else selectTpl">
      <section class="pv2-price-summary-card">
        <div class="pv2-price-summary-grid">
          <div class="pv2-price-summary-item">
            <span>Nome</span>
            <strong>{{ draft.nome || 'Nova tabela' }}</strong>
          </div>
          <div class="pv2-price-summary-item">
            <span>Canais</span>
            <strong>{{ canalLabel(draft.canal) }}</strong>
          </div>
          <div class="pv2-price-summary-item">
            <span>Prioridade</span>
            <strong>{{ draft.prioridade || 0 }}</strong>
          </div>
          <div class="pv2-price-summary-item">
            <span>Status</span>
            <strong class="pv2-price-pill" [class.is-active]="draft.ativo">{{ draft.ativo ? 'Ativa' : 'Inativa' }}</strong>
          </div>
          <div class="pv2-price-summary-item">
            <span>Atacado</span>
            <strong class="pv2-price-pill" [class.is-active]="draft.suportaPrecosAtacado">{{ draft.suportaPrecosAtacado ? 'Ativado' : 'Inativo' }}</strong>
          </div>
          <div class="pv2-price-summary-item pv2-price-summary-item--wide">
            <span>Disponibilidades</span>
            <div class="pv2-price-chip-list" *ngIf="draft.disponibilidades?.length; else semDisponibilidadeTpl">
              <span class="pv2-price-chip" *ngFor="let disponibilidade of draft.disponibilidades">
                {{ disponibilidade.descricao || ('Disponibilidade ' + disponibilidade.id) }}
              </span>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-light pv2-edit-table-btn" (click)="abraModalDadosTabela()">
          <span class="fa fa-cog mr-1"></span>
          Editar dados da tabela
        </button>
        <button type="button"
                class="btn pv2-activate-table-btn"
                *ngIf="!draft.ativo"
                (click)="ativeTabelaSelecionada()"
                [disabled]="saving">
          <span class="fa fa-power-off mr-1" *ngIf="!saving"></span>
          <span class="k-icon k-i-loading mr-1" *ngIf="saving"></span>
          Ativar tabela
        </button>
      </section>

      <section class="pv2-price-card" *ngIf="tabelaSelecionada?.id">
        <div class="pv2-price-card__title">
          <div>
            <h3>Valores dos produtos e adicionais na tabela <span class="badge badge-primary ml-1">{{tabelaSelecionada?.nome}}</span> </h3>
          </div>
          <button type="button" class="btn btn-primary pv2-copy-prices-btn" (click)="abraModalCopiarPrecos()" [disabled]="loadingItens || saving">
            <span class="fa fa-copy mr-1"></span>
            Copiar preços
          </button>
        </div>

        <div class="pv2-price-tabs">
          <button type="button" class="pv2-price-tab" [class.is-active]="abaAtiva === 'produtos'" (click)="altereAba('produtos')">
            <strong>Produtos</strong>
            <span>item, código PDV, texto</span>
          </button>
          <button type="button" class="pv2-price-tab" [class.is-active]="abaAtiva === 'adicionais'" (click)="altereAba('adicionais')">
            <strong>Adicionais</strong>
            <span>item, código PDV, texto</span>
          </button>
        </div>

        <div class="pv2-price-filters">
          <label class="pv2-form-field" *ngIf="abaAtiva === 'produtos'">
            <span>Categoria</span>
            <kendo-dropdownlist
              [data]="categoriasFiltro"
              [textField]="'nome'"
              [valueField]="'id'"
              [valuePrimitive]="true"
              [defaultItem]="{ id: null, nome: 'Todas' }"
              [(ngModel)]="categoriaFiltroId"
              (valueChange)="onCategoriaFiltroChange()">
            </kendo-dropdownlist>
          </label>
          <label class="pv2-form-field" *ngIf="abaAtiva === 'adicionais'">
            <span>Produto</span>
            <kendo-combobox
              [data]="produtosFiltroOpcoesVisiveis"
              [textField]="'nome'"
              [valueField]="'id'"
              [valuePrimitive]="true"
              [filterable]="true"
              [clearButton]="true"
              placeholder="Todos"
              [(ngModel)]="produtoFiltroId"
              (filterChange)="filtreProdutosFiltro($event)"
              (valueChange)="onProdutoFiltroChange($event)">
            </kendo-combobox>
          </label>
          <label class="pv2-form-field">
            <span>Código PDV</span>
            <input [(ngModel)]="codigoPdvFiltro" (ngModelChange)="onCodigoPdvFiltroChange()" type="text" placeholder="Ex.: 12345">
          </label>
          <label class="pv2-form-field pv2-form-field--search">
            <span>Buscar por texto</span>
            <input [(ngModel)]="search" (ngModelChange)="onBuscaFiltroChange()" type="text" placeholder="Ex.: hambúrguer, x-bacon, batata">
          </label>
          <button type="button" class="btn btn-outline-primary pv2-filter-btn" (click)="apliqueFiltros()">
            <span class="fa fa-filter mr-1"></span>
            Filtrar
          </button>
        </div>

        <div class="pv2-additional-switch" *ngIf="abaAtiva === 'adicionais' && produtoFiltroId && gruposAdicionaisFiltro.length">
          <div class="pv2-additional-switch__choice-group">
            <span class="pv2-additional-switch__choice-label">Adicional</span>
            <div class="pv2-additional-switch__segmented">
              <button type="button"
                      class="pv2-additional-switch__mode-btn"
                      [class.is-active]="!grupoAdicionalFiltroKey"
                      (click)="selecioneGrupoAdicionalFiltro(null)">
                <span class="fa fa-list"></span>
                <span>Todos</span>
              </button>
              <button type="button"
                      class="pv2-additional-switch__mode-btn"
                      *ngFor="let grupo of gruposAdicionaisFiltro"
                      [class.is-active]="grupoAdicionalFiltroKey === grupo.key"
                      (click)="selecioneGrupoAdicionalFiltro(grupo.key)">
                <span class="fa fa-cube"></span>
                <span class="pv2-additional-switch__mode-name" [title]="grupo.nome">{{ grupo.nome }}</span>
                <small>{{ grupo.total }}</small>
              </button>
            </div>
          </div>
        </div>

        <ng-container *ngIf="!loadingItens && !recalculandoLinhas; else loadingTpl">
          <ng-container *ngTemplateOutlet="tabelaPrecosGridTpl; context: { linhas: linhasFiltradasPaginadas, aba: abaAtiva, exibirBotaoAdicionais: abaAtiva === 'produtos' }"></ng-container>
        </ng-container>

        <div class="pv2-price-pagination" *ngIf="!loadingItens && !recalculandoLinhas && linhasFiltradas.length">
          <span>Mostrando {{ inicioExibicao }} a {{ fimExibicao }} de {{ linhasFiltradas.length }} {{ abaAtiva === 'produtos' ? 'produtos' : 'adicionais' }}</span>
          <div class="pv2-price-pages">
            <button type="button" class="btn btn-light btn-sm" (click)="vaParaPagina(paginaAtual - 1)" [disabled]="paginaAtual <= 1">
              <span class="fa fa-chevron-left"></span>
            </button>
            <ng-container *ngFor="let pagina of paginasVisiveis">
              <span class="pv2-price-page-ellipsis" *ngIf="!pagina">...</span>
              <button type="button"
                      class="btn btn-sm"
                      *ngIf="pagina"
                      [class.btn-primary]="paginaAtual === pagina"
                      [class.btn-light]="paginaAtual !== pagina"
                      (click)="vaParaPagina(pagina)">
                {{ pagina }}
              </button>
            </ng-container>
            <button type="button" class="btn btn-light btn-sm" (click)="vaParaPagina(paginaAtual + 1)" [disabled]="paginaAtual >= totalPaginas">
              <span class="fa fa-chevron-right"></span>
            </button>
          </div>
        </div>
      </section>
    </main>
  </div>

  <footer class="pv2-price-bottom-bar" *ngIf="!loading && draft">
    <button type="button" class="btn btn-light" (click)="descarteAlteracoes()" [disabled]="saving">
      <span class="fa fa-trash-o mr-1"></span>
      Descartar alterações
    </button>
    <button type="button" class="btn btn-success pv2-save-btn" (click)="salveAlteracoes()" [disabled]="!podeSalvarAlteracoes">
      <span class="fa fa-save mr-1" *ngIf="!saving"></span>
      <span class="k-icon k-i-loading mr-1" *ngIf="saving"></span>
      {{ saving ? 'Salvando...' : salvarAlteracoesLabel }}
    </button>
  </footer>
</section>

<ng-template #tabelaPrecosGridTpl
             let-linhas="linhas"
             let-aba="aba"
             let-exibirBotaoAdicionais="exibirBotaoAdicionais"
             let-ocultarGrupoAdicional="ocultarGrupoAdicional">
  <div class="pv2-price-grid"
       [class.pv2-price-grid--atacado]="draft.suportaPrecosAtacado"
       [class.pv2-price-grid--adicionais]="aba === 'adicionais'"
       [class.pv2-price-grid--sem-imagem]="ocultarGrupoAdicional">
    <div class="pv2-price-grid__head">
      <span>Item</span>
      <span>Código PDV</span>
      <span>{{ precoUnitarioLabel }}</span>
      <span>Desconto</span>
      <span *ngIf="draft.suportaPrecosAtacado">Preço atacado</span>
      <span *ngIf="draft.suportaPrecosAtacado">Qtd. mínima</span>
    </div>
    <div class="pv2-price-grid__row"
         *ngFor="let linha of linhas; trackBy: trackByLinha"
         [class.is-empty]="linha.item.valor == null && linha.item.desconto == null && linha.item.valorAtacado == null"
         [class.is-dirty]="linha.dirty"
         [class.is-invalid-wholesale]="linhaAtacadoInvalida(linha)"
         [class.is-invalid-discount]="linhaDescontoInvalida(linha)"
         [class.is-invalid-price]="linhaPrecoInvalida(linha)"
         [class.is-invalid-wholesale-price]="linhaPrecoAtacadoInvalido(linha)"
         [ngClass]="classeGrupoAdicional(linha, aba)">
      <div class="pv2-price-target">
        <span class="pv2-price-target__image" *ngIf="!ocultarGrupoAdicional" [class.is-placeholder]="!linha.imagem">
          <img *ngIf="linha.imagem" [src]="linha.imagem" [alt]="linha.nome">
          <span *ngIf="!linha.imagem">{{ linha.placeholderToken }}</span>
        </span>
        <div class="pv2-price-target__text">
          <strong>{{ nomeItemTabela(linha, aba, ocultarGrupoAdicional) }}</strong>
          <small class="pv2-price-target__meta">
            {{ subtituloItemTabela(linha, aba) }}
          </small>
          <div class="pv2-price-target__actions">
            <button type="button"
                    class="pv2-price-edit-product"
                    *ngIf="aba !== 'adicionais'"
                    (click)="abraEditorProduto(linha, $event)"
                    [disabled]="!linha.produtoId"
                    title="Editar produto">
              <span class="k-icon k-i-edit"></span>
            </button>
            <button type="button" title="Editar preços dos adicionais"
                    class="pv2-price-additional-table-btn"
                    *ngIf="exibirBotaoAdicionais && produtoTemAdicionais(linha)"
                    (click)="abraModalAdicionaisProduto(linha, $event)">
              <span class="fa fa-list-alt"></span>
              <span>adicionais</span>
            </button>
            <span class="pv2-price-dirty-badge" *ngIf="linha.dirty">Alterado</span>
            <span class="pv2-price-error-badge"
                  *ngIf="linhaPrecoInvalida(linha)"
                  title="Preço unitário deve ser maior ou igual a zero">
              <span class="k-icon k-i-warning"></span>
            </span>
            <span class="pv2-price-error-badge" *ngIf="linhaAtacadoInvalida(linha)">Qtd. atacado > 1</span>
            <span class="pv2-price-error-badge"
                  *ngIf="linhaPrecoAtacadoInvalido(linha)"
                  title="Preço atacado deve ser menor que o preço varejo">
              <span class="k-icon k-i-warning"></span>
            </span>
            <span class="pv2-price-error-badge"
                  *ngIf="linhaDescontoInvalida(linha)"
                  title="Desconto deve ser maior que zero e menor ou igual ao preço unitário">
              <span class="k-icon k-i-warning"></span>
            </span>
          </div>
        </div>
      </div>
      <span>{{ linha.codigoPdv || '-' }}</span>
      <div class="pv2-price-value-cell">
        <kendo-numerictextbox
          [(ngModel)]="linha.item.valor"
          (ngModelChange)="marqueLinhaAlterada(linha)"
          [class.is-invalid]="linhaPrecoInvalida(linha)"
          [min]="0"
          [spinners]="false"
          [format]="'c2'"
          placeholder="R$ 0,00">
        </kendo-numerictextbox>
        <span class="pv2-price-final" *ngIf="linhaTemDesconto(linha)">
          <span class="k-icon k-i-check-circle"></span>
          Final: {{ obtenhaPrecoFinal(linha) | currency:'BRL':'symbol':'1.2-2' }}
        </span>
        <span class="pv2-price-final-placeholder" *ngIf="!linhaTemDesconto(linha)"></span>
      </div>
      <div class="pv2-price-value-cell pv2-price-discount-cell">
        <kendo-numerictextbox
          [(ngModel)]="linha.item.desconto"
          (ngModelChange)="marqueLinhaAlterada(linha)"
          [class.is-invalid]="linhaDescontoInvalida(linha)"
          [min]="0"
          [spinners]="false"
          [format]="'c2'"
          placeholder="R$ 0,00">
        </kendo-numerictextbox>
        <span class="pv2-price-discount-percent" *ngIf="linhaTemDesconto(linha); else semDescontoTpl">
          {{ obtenhaPercentualDesconto(linha) | number:'1.1-1' }}%
        </span>
        <ng-template #semDescontoTpl>
          <span class="pv2-price-no-discount"></span>
        </ng-template>
      </div>
      <div class="pv2-price-value-cell" *ngIf="draft.suportaPrecosAtacado">
        <kendo-numerictextbox
          [(ngModel)]="linha.item.valorAtacado"
          (ngModelChange)="marqueLinhaAlterada(linha)"
          [class.is-invalid]="linhaPrecoAtacadoInvalido(linha)"
          [min]="0"
          [spinners]="false"
          [format]="'c2'"
          placeholder="R$ 0,00">
        </kendo-numerictextbox>
        <span class="pv2-price-final-placeholder"></span>
      </div>
      <div class="pv2-price-value-cell" *ngIf="draft.suportaPrecosAtacado">
        <input [(ngModel)]="linha.item.quantidadeMinimaAtacado" (ngModelChange)="marqueLinhaAlterada(linha)" type="number" step="1" min="2">
        <span class="pv2-price-final-placeholder"></span>
      </div>
    </div>
  </div>
</ng-template>

<div class="pv2-drawer-scrim" *ngIf="produtoAdicionaisModalOpen" (click)="fecheModalAdicionaisProduto()"></div>

<aside class="pv2-editor-drawer pv2-additional-prices-drawer" *ngIf="produtoAdicionaisModalOpen">
  <section class="pv2-additional-prices-modal">
    <header class="pv2-copy-modal__header">
      <button type="button" class="pv2-back-btn" (click)="fecheModalAdicionaisProduto()" [disabled]="saving">
        <span class="fa fa-arrow-left"></span>
        <span class="pv2-back-label">Voltar</span>
      </button>
      <div class="pv2-additional-prices-modal__heading">
        <span class="pv2-additional-prices-modal__image" *ngIf="produtoAdicionaisModalImagem">
          <img [src]="produtoAdicionaisModalImagem" [alt]="produtoAdicionaisModalNome">
        </span>
        <h3> <span>Produto</span>
          <strong>{{ produtoAdicionaisModalNome }}</strong></h3>
        <p class="pv2-copy-destination">
          preços adicionais em
          <span class="pv2-additional-prices-modal__table-badge">
            {{ draft?.nome || tabelaSelecionada?.nome }}
          </span>

        </p>
      </div>
      <div class="pv2-additional-prices-modal__header-actions">

      </div>
    </header>

    <div class="pv2-copy-modal__body">
      <div class="pv2-additional-switch" *ngIf="gruposAdicionaisProdutoModal.length">
        <div class="pv2-additional-switch__choice-group">
          <span class="pv2-additional-switch__choice-label">Adicional</span>
          <div class="pv2-additional-switch__segmented">
            <button type="button"
                    class="pv2-additional-switch__mode-btn"
                    *ngFor="let grupo of gruposAdicionaisProdutoModal"
                    [class.is-active]="grupoAdicionalModalFiltroKey === grupo.key"
                    (click)="selecioneGrupoAdicionalModal(grupo.key); $event.stopPropagation()">
              <span class="fa fa-cube"></span>
              <span class="pv2-additional-switch__mode-name" [title]="grupo.nome">{{ grupo.nome }}</span>
              <small>{{ grupo.total }}</small>
            </button>
          </div>
        </div>
      </div>

      <div class="pv2-additional-prices-modal__grid-scroll" *ngIf="linhasAdicionaisProdutoModal.length; else semAdicionaisProdutoTpl">
        <ng-container *ngTemplateOutlet="tabelaPrecosGridTpl; context: { linhas: linhasAdicionaisProdutoModal, aba: 'adicionais', exibirBotaoAdicionais: false, ocultarGrupoAdicional: true }"></ng-container>
      </div>
      <ng-template #semAdicionaisProdutoTpl>
        <div class="pv2-price-empty">Produto sem adicionais para editar nessa tabela.</div>
      </ng-template>
    </div>

    <footer class="pv2-copy-modal__footer">
      <button type="button" class="btn btn-light" (click)="fecheModalAdicionaisProduto()" [disabled]="saving">Fechar</button>
      <button type="button" class="btn btn-success" (click)="salveAlteracoes()" [disabled]="!podeSalvarAlteracoes">
        <span class="fa fa-save mr-1" *ngIf="!saving"></span>
        <span class="k-icon k-i-loading mr-1" *ngIf="saving"></span>
        {{ saving ? 'Salvando...' : salvarAlteracoesLabel }}
      </button>
    </footer>
  </section>
</aside>

<div class="pv2-copy-modal-backdrop" *ngIf="tabelaDadosModalOpen && tabelaDadosDraft">
  <section class="pv2-copy-modal pv2-table-modal">
    <header class="pv2-copy-modal__header pv2-table-modal__header">
      <span class="pv2-table-modal__icon">
        <span class="fa fa-list-alt"></span>
      </span>
      <div class="pv2-table-modal__heading">
        <h3>{{ tabelaDadosDraft.id ? 'Editar tabela' : 'Nova tabela' }}</h3>
        <p>{{ tabelaDadosDraft.id ? 'Dados, canais e disponibilidade' : 'Configure a nova tabela antes de editar preços' }}</p>
      </div>
      <button type="button" class="btn btn-light btn-sm pv2-table-modal__close" (click)="fecheModalDadosTabela()" [disabled]="saving">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-copy-modal__body pv2-table-modal__body">
      <div class="pv2-price-form-grid">
        <label class="pv2-form-field">
          <span>Nome da tabela</span>
          <input [(ngModel)]="tabelaDadosDraft.nome" type="text" placeholder="Ex: Delivery sexta">
        </label>
        <label class="pv2-form-field">
          <span>Canais</span>
          <kendo-multiselect
            [data]="canais"
            [textField]="'text'"
            [valueField]="'value'"
            [valuePrimitive]="true"
            [autoClose]="false"
            placeholder="Todos"
            [value]="canaisValue(tabelaDadosDraft)"
            (valueChange)="onCanaisChange($event)">
          </kendo-multiselect>

        </label>
        <label class="pv2-form-field">
          <span class="pv2-form-field__label">
            Prioridade
            <button type="button"
                    #prioridadeHelpAnchor
                    class="pv2-info-trigger"
                    (mouseenter)="prioridadeHelpOpen = true"
                    (mouseleave)="prioridadeHelpOpen = false"
                    aria-label="Como a prioridade funciona">
              <i class="fas fa-info-circle text-blue"></i>
            </button>
          </span>
          <input [(ngModel)]="tabelaDadosDraft.prioridade" type="number" step="1">
        </label>
      </div>

      <kendo-popup
        *ngIf="prioridadeHelpOpen"
        [anchor]="prioridadeHelpAnchor"
        [popupClass]="'pv2-priority-popup'">
        <div class="pv2-priority-help">
          <strong>Como a prioridade funciona</strong>
          <span>Maior número tem preferência quando mais de uma tabela puder ser aplicada.</span>
          <span>1. A tabela ativa de maior prioridade vence.</span>
          <span>2. Em empate, uma tabela com canal específico vence uma tabela marcada para todos os canais.</span>
        </div>
      </kendo-popup>

      <div class="pv2-table-modal__divider"></div>

      <div class="pv2-price-switches pv2-table-modal__switches">
        <label class="pv2-toggle-row pv2-toggle-row--activate" [class.is-inactive]="!tabelaDadosDraft.ativo">
          <span>{{ tabelaDadosDraft.ativo ? 'Tabela ativa' : 'Ativar tabela' }}</span>
          <kendo-switch
            name="tabelaPrecoAtivaModal"
            [(ngModel)]="tabelaDadosDraft.ativo"
            [onLabel]="'Sim'"
            [offLabel]="'Não'">
          </kendo-switch>
          <small *ngIf="!tabelaDadosDraft.ativo">A tabela nova fica inativa até você ativar manualmente.</small>
        </label>
        <label class="pv2-toggle-row">
          <span>Preço no atacado</span>
          <kendo-switch
            name="tabelaPrecoAtacadoModal"
            [(ngModel)]="tabelaDadosDraft.suportaPrecosAtacado"
            [onLabel]="'Sim'"
            [offLabel]="'Não'">
          </kendo-switch>
        </label>
      </div>

      <div class="pv2-initial-prices" *ngIf="!tabelaDadosDraft.id">
        <div class="pv2-initial-prices__title">
          <strong>Valores iniciais</strong>
          <span>após salvar</span>
        </div>
        <div class="pv2-initial-prices__notice" *ngIf="!tabelas.length">
          A primeira tabela será criada inativa e receberá os preços padrão de todos os produtos.
        </div>
        <div class="pv2-initial-prices__options" *ngIf="tabelas.length">
          <label>
            <input type="radio" name="criacaoValoresIniciais" [(ngModel)]="criacaoValoresIniciais" [value]="'COPIAR_TABELA'">
            Copiar preços de outra tabela
          </label>
          <select [(ngModel)]="criacaoTabelaOrigemId" [disabled]="criacaoValoresIniciais !== 'COPIAR_TABELA'">
            <option *ngFor="let tabela of tabelasParaCopiaCriacao" [ngValue]="tabela.id">{{ tabela.nome }}</option>
          </select>
          <label>
            <input type="radio" name="criacaoValoresIniciais" [(ngModel)]="criacaoValoresIniciais" [value]="'VAZIA'">
            Criar sem valores iniciais
          </label>
        </div>
      </div>

      <div class="pv2-price-disps">
        <app-view-disponibilidade
          [disponibilidades]="tabelaDadosDraft.disponibilidades"
          [catalogo]="empresa?.catalogo">
        </app-view-disponibilidade>
      </div>
    </div>

    <footer class="pv2-copy-modal__footer pv2-table-modal__footer">
      <button type="button" class="btn btn-danger" *ngIf="tabelaDadosDraft.id" (click)="removaTabela(tabelaDadosDraft)" [disabled]="saving">
        <span class="fa fa-trash mr-1"></span>
        Remover
      </button>
      <span *ngIf="!tabelaDadosDraft.id"></span>
      <div class="pv2-table-modal__actions">
        <button type="button" class="btn btn-light" (click)="fecheModalDadosTabela()" [disabled]="saving">Cancelar</button>
        <button type="button" class="btn btn-success" (click)="salveTabela()" [disabled]="saving">
          <span class="k-icon k-i-loading mr-1" *ngIf="saving"></span>
          {{ saving ? 'Salvando...' : 'Salvar tabela' }}
        </button>
      </div>
    </footer>
  </section>
</div>

<div class="pv2-drawer-scrim" *ngIf="drawerOpen" (click)="onDrawerClosed()"></div>

<aside class="pv2-editor-drawer" *ngIf="drawerOpen">
  <app-tela-editor-produto-v2
    [embedded]="true"
    [productId]="drawerProductId"
    [surfaceMode]="drawerSurface"
    (closeRequested)="onDrawerClosed()"
    (productPersisted)="carregueItensTabela()">
  </app-tela-editor-produto-v2>
</aside>

<div class="pv2-copy-modal-backdrop" *ngIf="copiarPrecosModalOpen">
  <section class="pv2-copy-modal">
    <header class="pv2-copy-modal__header">
      <div>
        <h3>Copiar preços para tabela</h3>
        <p class="pv2-copy-destination">
          <span>Destino</span>
          <strong>{{ draft?.nome }}</strong>
        </p>
      </div>
      <button type="button" class="btn btn-light btn-sm" (click)="fecheModalCopiarPrecos()" [disabled]="saving || carregandoOrigemCopia">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-copy-modal__body">
      <div class="pv2-copy-form-grid">
        <label class="pv2-form-field">
          <span>Origem</span>
          <select [(ngModel)]="copiaOrigemValue" (ngModelChange)="onCopiaOrigemChange($event)">
            <option *ngFor="let origem of opcoesOrigemCopia" [ngValue]="origem.value">{{ origem.text }}</option>
          </select>
        </label>

        <div class="pv2-copy-options">
          <span>Copiar</span>
          <label>
            <input type="checkbox" [(ngModel)]="copiaPrecoUnitario">
            {{ precoUnitarioLabel }}
          </label>
          <label [class.is-disabled]="!podeCopiarAtacado">
            <input type="checkbox" [ngModel]="copiaPrecoAtacado" (ngModelChange)="onCopiaAtacadoChange($event)" [disabled]="!podeCopiarAtacado">
            Preço atacado
          </label>
          <small *ngIf="!podeCopiarAtacado">{{ mensagemAtacadoIndisponivel }}</small>
        </div>
      </div>

      <div class="pv2-copy-loading" *ngIf="carregandoOrigemCopia">Carregando preços da origem...</div>

      <div class="pv2-copy-adjust" *ngIf="!carregandoOrigemCopia">
        <div class="pv2-copy-adjust__title">
          <strong>Ajustar preços</strong>
          <span>Opcional</span>
        </div>
        <p>Aplique um valor ou percentual para ajustar os preços copiados.</p>
        <div class="pv2-copy-adjust__grid">
          <label class="pv2-form-field">
            <span>Tipo de ajuste</span>
            <select [(ngModel)]="copiaAjusteTipo">
              <option [ngValue]="'PERCENTUAL'">Percentual (%)</option>
              <option [ngValue]="'VALOR'">Valor (R$)</option>
            </select>
          </label>
          <label class="pv2-form-field">
            <span>Valor do ajuste</span>
            <kendo-numerictextbox
              [(ngModel)]="copiaAjusteValor"
              [min]="0"
              [spinners]="false"
              [format]="copiaAjusteTipo === 'PERCENTUAL' ? 'n2' : 'c2'"
              placeholder="0,00">
            </kendo-numerictextbox>
          </label>
          <label class="pv2-form-field">
            <span>Operação</span>
            <select [(ngModel)]="copiaAjusteOperacao">
              <option [ngValue]="'AUMENTAR'">Aumentar (+)</option>
              <option [ngValue]="'DIMINUIR'">Diminuir (-)</option>
            </select>
          </label>
          <div class="pv2-copy-adjust__example">
            <span>Exemplo de cálculo</span>
            <strong>
              {{ copiaExemploOrigem | currency:'BRL':'symbol':'1.2-2' }}
              {{ ajusteOperacaoSinal() }}{{ (copiaAjusteValor || 0) | number:'1.2-2' }}{{ copiaAjusteTipo === 'PERCENTUAL' ? '%' : '' }}
              <span class="pv2-copy-arrow">→</span>
              <em>{{ copiaExemploAjustado | currency:'BRL':'symbol':'1.2-2' }}</em>
            </strong>
          </div>
        </div>
      </div>

      <div class="pv2-copy-summary" *ngIf="!carregandoOrigemCopia">
        <div>
          <strong>{{ itensParaCopia.length }}</strong>
          <span>itens serão copiados</span>
        </div>
        <div>
          <strong>{{ copiaTotalProdutos }}</strong>
          <span>produtos</span>
        </div>
        <div>
          <strong>{{ copiaTotalAdicionais }}</strong>
          <span>adicionais</span>
        </div>
      </div>

      <div class="pv2-copy-preview" *ngIf="!carregandoOrigemCopia && copiaPreview.length">
        <div class="pv2-copy-preview__title">
          <strong>Amostra</strong>
          <span>Primeiros {{ copiaPreview.length }} itens que serão copiados</span>
        </div>
        <div class="pv2-copy-grid" [class.pv2-copy-grid--atacado]="copiaPrecoAtacado && podeCopiarAtacado">
          <div class="pv2-copy-grid__head">
            <span>Alvo</span>
            <span>Tipo</span>
            <span *ngIf="copiaPrecoUnitario">Preço atual</span>
            <span *ngIf="copiaPrecoUnitario">Preço origem</span>
            <span *ngIf="copiaPrecoUnitario">Preço após ajuste</span>
            <span *ngIf="copiaPrecoAtacado && podeCopiarAtacado">Atacado</span>
            <span *ngIf="copiaPrecoAtacado && podeCopiarAtacado">Qtd. mínima</span>
          </div>
          <div class="pv2-copy-grid__row" *ngFor="let item of copiaPreview">
            <strong>{{ item.linha.nome }}</strong>
            <span>{{ item.linha.tipoLabel }}</span>
            <span *ngIf="copiaPrecoUnitario">
              {{ item.valorAtual != null ? (item.valorAtual | currency:'BRL':'symbol':'1.2-2') : '-' }}
            </span>
            <span *ngIf="copiaPrecoUnitario">
              {{ item.valorOrigem != null ? (item.valorOrigem | currency:'BRL':'symbol':'1.2-2') : '-' }}
            </span>
            <span *ngIf="copiaPrecoUnitario" class="pv2-copy-adjusted-price">
              {{ item.valorNovo != null ? (item.valorNovo | currency:'BRL':'symbol':'1.2-2') : '-' }}
            </span>
            <span *ngIf="copiaPrecoAtacado && podeCopiarAtacado">
              {{ item.valorAtacadoAtual != null ? (item.valorAtacadoAtual | currency:'BRL':'symbol':'1.2-2') : '-' }}
              <span class="pv2-copy-arrow">→</span>
              {{ item.valorAtacadoNovo != null ? (item.valorAtacadoNovo | currency:'BRL':'symbol':'1.2-2') : '-' }}
            </span>
            <span *ngIf="copiaPrecoAtacado && podeCopiarAtacado">
              {{ item.quantidadeAtual != null ? item.quantidadeAtual : '-' }}
              <span class="pv2-copy-arrow">→</span>
              {{ item.quantidadeNova != null ? item.quantidadeNova : '-' }}
            </span>
          </div>
        </div>
      </div>

      <div class="pv2-price-empty" *ngIf="!carregandoOrigemCopia && !copiaPreview.length">
        Nenhum preço disponível para copiar com os critérios selecionados.
      </div>
    </div>

    <footer class="pv2-copy-modal__footer">
      <button type="button" class="btn btn-light" (click)="fecheModalCopiarPrecos()" [disabled]="saving || carregandoOrigemCopia">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="copiePrecos()" [disabled]="!podeConfirmarCopia">
        <span class="k-icon k-i-loading mr-1" *ngIf="saving"></span>
        Copiar preços ({{ itensParaCopia.length }} itens)
      </button>
    </footer>
  </section>
</div>

<ng-template #loadingTpl>
  <div class="pv2-price-empty">Carregando...</div>
</ng-template>

<ng-template #semDisponibilidadeTpl>
  <span class="pv2-price-muted">Todas</span>
</ng-template>

<ng-template #selectTpl>
  <main class="pv2-price-editor">
    <div class="pv2-price-empty">Selecione uma tabela ou crie uma nova.</div>
  </main>
</ng-template>
